import WidgetModule from "@eisinc/Overrides/Widgets/SignIn/SignInResetPasswordForm";

export * from "@eisinc/Overrides/Widgets/SignIn/SignInResetPasswordForm";

export default WidgetModule;
